<template>
    <div class="auth-wrapper auth-v2 bg-white">
        <b-row class="auth-inner m-0">
            <div class="w-100 d-flex flex-column justify-content-between">
                <div class="px-1  bg-white flex-fill">
                    <div class="d-flex flex-column  mt-3  bg-white flex-fill">
                        
                            <div class="headTitle mt-2"> Módulo Avanzado - Asesoría</div>
                            <validation-observer ref="registerForm" #default="{ invalid }">
                                <b-form-group >
                                    <validation-provider #default="{ errors }" name="CVO" vid="CVO" rules="required">
                                        <b-form-input id="register-CVO" v-model="CVO" name="register-CVO"
                                            :state="errors.length > 0 ? false : null" placeholder="" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                              
                            </validation-observer>  
             
                   <img src="@/assets/images/ganImage/map.png" class="mt-1" />
           
                    </div>
                      <div class="d-flex justify-content-center mt-3 ">  <b-button   class=" bg-primary buttonIndex d-flex justify-content-center "  ><b-link :to="{name:'advance-advicetext'}" style="color:white">Obtener Asesoría</b-link></b-button></div>
                </div>
            </div>
        </b-row>
        <ControlMenu />
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ControlMenu from '@/components/ControlMenu.vue'
import {
    BRow, BCol, BLink, BButton, BForm, BFormCheckbox, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BImg, BCardTitle, BCardText,
} from 'bootstrap-vue'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

export default {
    components: {
        BRow,
        ControlMenu,
        BImg,
        BCol,
        BLink,
        BButton,
        BForm,
        BCardText,
        BCardTitle,
        BFormCheckbox,
        BFormGroup,
        BFormInput,
        BInputGroup,
        BInputGroupAppend,
        // validations
        ValidationProvider,
        ValidationObserver,
    },
    mixins: [togglePasswordVisibility],
    data() {
        return {
            status: '',
            CVO: '',
        }
    },

}
</script>

<style>
.mapIndex {
    z-index: 100;
}
.buttonIndex {
    z-index: 1000;
    top:70%
}
.headTitle {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 23px;
    line-height: 29px;
    color: #5E5873;

}
</style>